var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-1 text-subtitle-2"},[_vm._v(" "+_vm._s(_vm.Label)),(_vm.alert)?_c('span',{staticClass:"ml-2"},[_vm._v("※"+_vm._s(_vm.alert))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }